import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { capitalize, Dialog, Grid, MenuItem, Select } from '@mui/material';

import { BinType } from 'commons/enums';
import { updateBinType } from 'redux-stores/actions';
import { AppDispatch } from 'redux-stores/store';

import S from '../styles/EditBinDialog.styles';
import { IEditableBin, IEditBinModalProps } from '../types';

export const EditBinTypeDialog: React.FC<IEditBinModalProps<IEditableBin>> = ({
  onClose,
  openModal,
  location,
  binData,
}) => {
  const [bin, setBin] = useState<Partial<IEditableBin>>(binData);
  const [newBinType, setNewBinType] = useState<string>(binData.bin_type);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    setBin(binData);
  }, [binData]);

  const onConfirm = async (): Promise<void> => {
    if (bin && bin.bin && bin.bin_type && newBinType) {
      dispatch(updateBinType({ bin: bin.bin, newBinType, location }));
    }
  };

  const isConfirmDisabled = (): boolean => {
    return !(newBinType && newBinType.trim() !== bin.bin_type);
  };

  return (
    <Dialog
      onClose={onClose}
      open={openModal}
      style={{ whiteSpace: 'pre-line' }}
    >
      <S.TitleWrapper>
        <S.Title>Edit Bin Type</S.Title>
      </S.TitleWrapper>
      <Grid container style={{ marginTop: '12px', width: '500px' }}>
        <S.FieldRowWrapper container item xs={12} spacing={2}>
          <Grid item xs={5}>
            <S.Text>Bin</S.Text>
          </Grid>
          <S.InputWrapper item xs={7}>
            <S.Text>{bin.bin}</S.Text>
          </S.InputWrapper>
        </S.FieldRowWrapper>
        <S.FieldRowWrapper container item xs={12} spacing={2}>
          <Grid item xs={5}>
            <S.Text>New Bin Type</S.Text>
          </Grid>
          <S.InputWrapper>
            <Select
              data-testid="dropdownEditBinType"
              value={newBinType || ''}
              onChange={(event): void =>
                setNewBinType(event.target.value || '')
              }
              fullWidth
              style={{ marginTop: '12px' }}
            >
              {Object.values(BinType)
                .filter(
                  (_binType) =>
                    ![BinType.PALLET, BinType.NONE].includes(_binType),
                )
                .map((_binType) => (
                  <MenuItem value={_binType}>
                    {capitalize(_binType.replace('_', ' '))}
                  </MenuItem>
                ))}
            </Select>
          </S.InputWrapper>
        </S.FieldRowWrapper>
      </Grid>
      <S.FooterWrapper>
        <S.SecondaryButton onClick={onClose}>Cancel</S.SecondaryButton>
        <S.PrimaryButton
          onClick={() => {
            onConfirm();
            onClose();
          }}
          disabled={isConfirmDisabled()}
        >
          Update
        </S.PrimaryButton>
      </S.FooterWrapper>
    </Dialog>
  );
};
